class Auth {
  static getToken() {
    return sessionStorage.getItem("accessToken");
  }

  static getUserDetails(key = null) {
    try {
      const user = sessionStorage.getItem("user");
      if (!user) return null;

      const parsed = JSON.parse(user);

      if (parsed.role) parsed.role = parsed.role.toLowerCase();

      return key ? parsed[key] : parsed;
    } catch {
      return null;
    }
  }

  static logout() {
    sessionStorage.clear();
    window.location.replace("/");
  }
}

export default Auth;
